import { Controller } from "@hotwired/stimulus";
import { Datepicker } from "vanillajs-datepicker";
import { i18n } from "../../utils/i18n";

const months = [...i18n.t("date.month_names")];
months.shift();
const monthsShort = [...i18n.t("date.abbr_month_names")];
monthsShort.shift();

const days = i18n.t("date.day_names");
const daysShort = i18n.t("date.abbr_day_names");
const daysMin = Array.from(i18n.t<string[]>("date.abbr_day_names")).map(
  (name) => `${name[0]}${name[1]}`
);

// .datepicker-cell
Datepicker.locales[i18n.locale] = {
  days,
  daysShort,
  daysMin,
  months,
  monthsShort,
  today: i18n.t("datepicker.today"),
  clear: i18n.t("datepicker.clear"),
  titleFormat: i18n.t("datepicker.title_format")
};

export default class extends Controller {
  static targets = ["calendar", "input"];
  static values = {
    pickLevel: { type: Number, default: 0 },
    maxView: { type: Number, default: 0 },
    startView: { type: Number, default: 0 }
  };
  datepicker;

  declare readonly inputTarget: HTMLInputElement;
  declare readonly hasInputTarget: boolean;

  declare readonly pickLevelValue: number;
  declare readonly maxViewValue: number;
  declare readonly startViewValue: number;

  connect() {
    this.datepicker = new Datepicker(this.inputTarget, {
      buttonClass:
        "bg-white dark:bg-gray-700 rounded-lg text-gray-500 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-600 hover:text-gray-900 dark:hover:text-white text-lg p-2.5 focus:outline-none focus:ring-2 focus:ring-gray-200 leading-5",
      autohide: true,
      prevArrow:
        '<svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clip-rule="evenodd"></path></svg>',
      nextArrow:
        '<svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>',
      orientation: "bottom auto",
      language: i18n.locale,
      format: this.inputTarget.dataset.format,
      todayHighlight: true,
      pickLevel: this.pickLevelValue,
      maxView: this.maxViewValue,
      startView: this.startViewValue
    });

    this.inputTarget.autocomplete = "off";
  }
}
